import { MenuItem } from '@mui/material';
import { CustomSelectAndChildren } from '../../../components/CustomSelectAndChildren';
import LogsApp from './Functionality/LogsApp';
import HeadTittle from '../../../components/HeadTittle';
import StepTab from '../../../components/StepperTabs/StepTab';
import StepperTabs from '../../../components/StepperTabs/StepperTabs';
import ActionLogsTab from './Subcomponents/ActionLogsTab';
import AccessLogsTab from './Subcomponents/AccessLogsTab';
import { permissionObj } from '../../../Helpers/permission';
import routes from '../../../Routes/routes';
/**
 * @Author: Karen Yunuen Pozos Arias
 * @JobTitle: Full Stack Developer - IBL
 * @Email: kpozos@ibl.mx
 */
const Logs = () => {
    const {
        t,
        steps,
        activeStep,
        setActiveStep,
        modified,
        setModified,
        modelType,
        setModelType,
        finalArray,
        getListSearchModels,
        handleStepChange,
        DEV,
        permission,
        navigate,
    } = LogsApp();

    if (
        !DEV &&
        !permission?.includes(permissionObj?.WEB_LOG_PLATFORM_READ) &&
        !permission?.includes(permissionObj?.WEB_LOG_ACTION_READ)
    )
        navigate(routes.forbidden);

    return (
        <>
            <HeadTittle name={'logs'}></HeadTittle>
            <StepperTabs
                onlyTab={true}
                disabled={false}
                steps={steps}
                activeStep={activeStep}
                isStepOptional={() => {}}
                setActiveStep={setActiveStep}
                handleStepChange={handleStepChange}
            >
                <StepTab index={0} activeStep={activeStep}>
                    {activeStep === 0 && (
                        <>
                            <CustomSelectAndChildren
                                id={'slt_lgs_model'}
                                name={'model'}
                                trans={'model'}
                                onChange={(e) => {
                                    setModelType(e.target.value);
                                    setModified(true);
                                }}
                                value={modelType}
                            >
                                {getListSearchModels?.map((item) => (
                                    <MenuItem key={item} value={item}>
                                        {t(item).toLocaleUpperCase()}
                                    </MenuItem>
                                ))}
                            </CustomSelectAndChildren>
                            <ActionLogsTab
                                modelType={modelType}
                                finalArray={finalArray}
                                modified={modified}
                                setModified={setModified}
                            />
                        </>
                    )}
                </StepTab>
                <StepTab index={1} activeStep={activeStep}>
                    {activeStep === 1 && (
                        <AccessLogsTab finalArray={finalArray} modified={modified} setModified={setModified} />
                    )}
                </StepTab>
            </StepperTabs>
        </>
    );
};

export default Logs;
